import Image from 'components/image'
import { InfoButton } from 'components/buttons'
import OfferList from 'components/offer-list/offer-list'
import Link from 'components/link'
import { withContextualizedTracking, track } from 'lib/analytics'
import css from './styles.scss'
import { getSearchPreviewIds } from 'components/global-nav/components/SearchBar/SearchBar.utils'

export interface ProductSpotlightProps {
  anchor: string
  sponsored?: boolean
  sponsoredHeading?: string
  sponsoredBrandLogo?: {
    description: string
    url: string
  }
  sponsoredLinkUrl?: string
  product: {
    id?: number
    brand?: string
    generic_product_name?: string
    image: { url: string }
    name: string
    short_name: string
    teaser: string
    normal_url: string
    offers: Array<{
      name: string
      normal_url: string
      price: string
      store: { name: string }
      url: string
      viglink_enabled: boolean
    }>
    url: string
  }
  description: string
  primaryCTAOption?: string
}

export const SponsoredHeader = ({ heading, logo, url }: any) => (
  <Link
    className="text-body link-body block mbl flex align-center"
    url={url}
    newWindow
  >
    <div className="tiny text-uppercase mrs">{heading || 'Sponsored'}</div>
    {logo && <Image src={logo} width={80} className="mts" />}
  </Link>
)

const handleProductClick = (product: any) => {
  let { price } = product.offers[0]
  if (price && typeof price === 'string') {
    price = price.replace('$', '')
    price = parseFloat(price)
  }
  const searchPreviewIds = getSearchPreviewIds()
  track.productClicked({
    productPrice: price || 0,
    productType: track.ProductType.PRODUCT,
    eventLocation: track.EventLocation.GUIDE,
    searchPreviewIds,
  })
}

const handleAddToRegistry = (product: any) => {
  bl.addToRegistry({
    images: product.image.url,
    price: product.offers[0].price,
    product_id: product.id,
    title: product.name,
    url: product.normal_url,
    source: 'hello_baby',
  })
}
function ProductSpotlight({
  anchor,
  sponsored,
  sponsoredHeading,
  sponsoredBrandLogo,
  sponsoredLinkUrl,
  product,
  description,
  primaryCTAOption,
}: ProductSpotlightProps) {
  const primaryOffer = product.offers[0]
  const pdpUrl = primaryOffer?.url
  const viglinkEnabled = primaryOffer?.viglink_enabled
  const ActionButtons = ({ product }: any) => {
    switch (primaryCTAOption) {
      case 'Add to Babylist':
        return (
          <>
            <InfoButton
              onClick={() => handleAddToRegistry(product)}
              className="mvm mrm"
              pill
              block
            >
              Add to Babylist
            </InfoButton>
            <InfoButton
              href={pdpUrl}
              className="mvm"
              block
              pill
              empty
              newWindow
            >
              Buy Now
            </InfoButton>
          </>
        )
      default:
        return (
          <>
            <InfoButton
              href={pdpUrl}
              className="mvm mrm"
              block
              pill
              newWindow
              rel={viglinkEnabled ? '' : 'norewrite'}
            >
              Buy Now
            </InfoButton>
            <InfoButton
              onClick={() => handleAddToRegistry(product)}
              className="mvm"
              pill
              block
              empty
            >
              Add to Babylist
            </InfoButton>
          </>
        )
    }
  }

  return (
    <div className={css.root}>
      <div id={anchor} className="product-section-anchor" />
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div className={css.grid} onClick={() => handleProductClick(product)}>
        <Link url={pdpUrl} newWindow>
          <Image className="img-responsive" src={product.image.url} />
        </Link>
        <div>
          {sponsored && (
            <SponsoredHeader
              heading={sponsoredHeading}
              logo={sponsoredBrandLogo?.url}
              url={sponsoredLinkUrl}
            />
          )}
          <div>
            {product.brand && (
              <div className="xsmall mtm text-uppercase">{product.brand}</div>
            )}
            <div className="text-bold mvs h1 lh-sm">
              <Link className="link-body-text" url={pdpUrl} newWindow>
                {product.generic_product_name}
              </Link>
            </div>
            <div className="flex align-center">
              <ActionButtons product={product} />
            </div>
            {description && (
              <div
                className="phm"
                dangerouslySetInnerHTML={{ __html: description }}
              />
            )}
            {/* @ts-ignore */}
            <OfferList className="mtl" offers={product.offers} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default withContextualizedTracking({
  eventLocation: track.EventLocation.GUIDE,
})(ProductSpotlight)
